import { partners } from './partners';
import { selectDate } from './select-date';
import { editAppointment } from './edit';

export const routesReducers = {
  partners,
  selectDate,
  editAppointment,
};
